import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectIsInProgress } from '../../spinner/ducks';
import { selectToken } from '../../../features/auth/ducks';
import { apiCallIds } from '../../messaging-dashboard/api';
import { fetchEmailLogActions, selectEmailLog } from '../ducks';
import { EmailLogDetail } from '../components';
import Spin from 'antd/lib/spin';


const mapStateToProps = (state, props) => ({
  emailLog: selectEmailLog(state),
  token: selectToken(state),
  emailLogId: props.params.emailLogId,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchEmailLog: fetchEmailLogActions.request,
    },
    dispatch
  )
});


@connect(mapStateToProps, mapDispatchToProps)
export default class EmailLogDetailContainer extends Component {
  static propTypes = {
    actions: PropTypes.object,
    token: PropTypes.string.isRequired,
    emailLogId: PropTypes.string.isRequired
  };


  constructor(props) {
    super(props);
    this.state = { emailLog: {} };
  }

  componentDidMount() {
    const { actions, emailLogId } = this.props;
    actions.fetchEmailLog({ emailLogId });

  }


  render() {
    const { emailLog, token } = this.props;
    return (
      <div>
        {!emailLog ?
          <Spin className="dasboard-spinner" spinning={!emailLog}>
            <div className="spin-empty-content" />
          </Spin> :
          <EmailLogDetail
            emailLog={emailLog}
            token={token}>
          </EmailLogDetail>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/messaging-dashboard/containers/EmailLogDetailContainer.js